module.exports = __webpack_public_path__ + "img/burger-ig-ex-7.42d0702d.svg";